var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wf-current-refinements" }, [
    _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c(
          "div",
          {
            staticClass:
              "wf-current-refinements-title mb-1 text-uppercase filter-counter p-1"
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.images.length) +
                " " +
                _vm._s(
                  _vm.$resourceString["product.search.filters.results.for"]
                ) +
                "\n        "
            ),
            _c(
              "button",
              {
                staticClass:
                  "clear-filters-btn text-uppercase text-decoration-none ml-3 pl-2",
                on: { click: _vm.clearAllFilters }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$resourceString["inspiration.images.filters.clear.all"]
                  )
                )
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-12" },
        _vm._l(Object.entries(_vm.selectedFilters), function(ref) {
          var k = ref[0]
          var filterOptions = ref[1]
          return _c(
            "div",
            { key: k, staticClass: "wf-current-refinements-group" },
            [
              _vm._l(filterOptions, function(option) {
                return [
                  !_vm.isSingleCharOrNum(option) &&
                  !_vm.isUniqueProductId(option)
                    ? _c(
                        "a",
                        {
                          key: option,
                          staticClass:
                            "btn font-size-12 mx-1 my-1 btn-light p-1"
                        },
                        [
                          _c("span", { staticClass: "mr-3" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  option == "1"
                                    ? _vm.$resourceString[
                                        "product.search.filters.current." +
                                          k.toLowerCase()
                                      ]
                                    : option
                                ) +
                                "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", {
                            staticClass:
                              "png-icon png-icon-icons-glyph--k-close",
                            on: {
                              click: function($event) {
                                return _vm.deselectFilter({
                                  filterName: k,
                                  option: option
                                })
                              }
                            }
                          })
                        ]
                      )
                    : _vm._e()
                ]
              })
            ],
            2
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }